<template>
  <Modal title="Demo Reivew V2" v-model="showModal" width="750">
    <Row>
      <div class="evaluate">
        <h2>Part one: Learning Status </h2>

        <h3>Child’s Engagement  : <span class="choose">(Please choose a type)</span>  <span>
          <Button :type="partData.part1.type === 'typeA' ? 'primary' : 'default'" @click="changeType('part1', 'typeA')">typeA</Button>
          <Button :type="partData.part1.type === 'typeB' ? 'primary' : 'default'" @click="changeType('part1', 'typeB')">typeB</Button>
          <Button :type="partData.part1.type === 'typeC' ? 'primary' : 'default'" @click="changeType('part1', 'typeC')">typeC</Button>
        </span></h3>
        <h4 v-if="partData.part1.type === 'typeA'">
          Hi {{nickname}}, you were highly engaged in class, showing exceptional participation! You asked questions proactively and made great efforts to use new sentence structures in your responses. Excellent work in class today!
        </h4>
        <h4 v-if="partData.part1.type === 'typeB'">
          Hi {{nickname}}, you were overall active in class participation, though you occasionally needed gentle prompts (e.g., hand gestures) to share more details or join in. Keep up the good work—your involvement was fantastic!
        </h4>
        <h4 v-if="partData.part1.type === 'typeC'">
          Hi {{nickname}}, you seemed a bit shy in class, responding to questions in a soft voice and rarely initiating conversations. It was wonderful to see you try when guided patiently, though! Looking forward to seeing more of your participation in future classes—you’ve got this!
        </h4>
      </div>
    </Row>
    <Row>
      <div class="evaluate">
        <h2>Part two: Learning Ability  :</h2>
        <h3>1. Listening Ability Evaluation  :<span class="choose">(Please choose a type)</span>  <span>
          <Button :type="partData.part2.type === 'typeA' ? 'primary' : 'default'" @click="changeType('part2', 'typeA')">typeA</Button>
          <Button :type="partData.part2.type === 'typeB' ? 'primary' : 'default'" @click="changeType('part2', 'typeB')">typeB</Button>
          <Button :type="partData.part2.type === 'typeC' ? 'primary' : 'default'" @click="changeType('part2', 'typeC')">typeC</Button>
        </span></h3>
        <h4 v-if="partData.part2.type === 'typeA'">
          <span class="title">you grasped information accurately and followed instructions flawlessly</span>. You also demonstrated clear understanding of key details like greetings, class extensions, and dialogues/passages in the materials.
        </h4>
        <h4 v-if="partData.part2.type === 'typeB'">
          <span class="title">you comprehended information adequately and followed most instructions correctly</span>. You understood surface-level details such as basic greetings, simple class extensions, and straightforward dialogues from the materials.
        </h4>
        <h4 v-if="partData.part2.type === 'typeC'">
          <span class="title">you grasped information vaguely and followed some of the instructions correctly</span>. Besides, you required repeated instructions and demonstrations to process even foundational elements like basic greetings, simple class cues, or short phrases from the materials.
        </h4>
        <h3>2. Oral Ability Evaluation  :<span class="choose">(Please choose a type)</span>  <span>
          <Button :type="partData.part3.type === 'typeA' ? 'primary' : 'default'" @click="changeType('part3', 'typeA')">typeA</Button>
          <Button :type="partData.part3.type === 'typeB' ? 'primary' : 'default'" @click="changeType('part3', 'typeB')">typeB</Button>
          <Button :type="partData.part3.type === 'typeC' ? 'primary' : 'default'" @click="changeType('part3', 'typeC')">typeC</Button>
        </span></h3>
        <h4 v-if="partData.part3.type === 'typeA'">
          You demonstrated excellent speaking skills with clear pronunciation—only minor slips, such as <input type="text" v-model="partData.part3.words" >, and fluent verbal output. You voluntarily spoke in full sentences, showing strong command of the content.
        </h4>
        <h4 v-if="partData.part3.type === 'typeB'">
          Your speaking skills were moderate, with minor pronunciation issues (e.g., <input type="text" v-model="partData.part3.words" >) and average fluency. You could expand into full sentences when prompted, showing basic ability to elaborate.
        </h4>
        <h4 v-if="partData.part3.type === 'typeC'">
          Your speaking skills were weak, with frequent pronunciation errors (e.g., <input type="text" v-model="partData.part3.words" >). You often got stuck mid-sentence, struggling with words or phrases, and required word-by-word guidance to complete expressions.
        </h4>
        <h3>3. Reading Ability Evaluation  :<span class="choose">(Please choose a type)</span>  <span>
          <Button :type="partData.part4.type === 'typeA' ? 'primary' : 'default'" @click="changeType('part4', 'typeA')">typeA</Button>
          <Button :type="partData.part4.type === 'typeB' ? 'primary' : 'default'" @click="changeType('part4', 'typeB')">typeB</Button>
          <Button :type="partData.part4.type === 'typeC' ? 'primary' : 'default'" @click="changeType('part4', 'typeC')">typeC</Button>
        </span></h3>
        <h4 v-if="partData.part4.type === 'typeA'">
          You read fluently and expressively, with a strong grasp of underlying logic. New and high-frequency words were pronounced correctly, with natural pauses at phrase chunks.
        </h4>
        <h4 v-if="partData.part4.type === 'typeB'">
          Your reading was somewhat halting, but you grasped surface meanings well. Most words were correct, with slight pauses on longer ones.
        </h4>
        <h4 v-if="partData.part4.type === 'typeC'">
          Your reading was halting, with recognition limited to basics. Mispronunciations and struggles with new words were common.
        </h4>
        <h3>4. Grammar & Vocabulary Evaluation  :<span class="choose">(Please choose a type)</span>  <span>
          <Button :type="partData.part5.type === 'typeA' ? 'primary' : 'default'" @click="changeType('part5', 'typeA')">typeA</Button>
          <Button :type="partData.part5.type === 'typeB' ? 'primary' : 'default'" @click="changeType('part5', 'typeB')">typeB</Button>
          <Button :type="partData.part5.type === 'typeC' ? 'primary' : 'default'" @click="changeType('part5', 'typeC')">typeC</Button>
        </span></h3>
        <h4 v-if="partData.part5.type === 'typeA'">
          Your grammar and vocabulary were advanced. You made only occasional minor grammar errors <input type="text" v-model="partData.part5.words" >(e.g., tense misuse, article/plural mistakes, verb collocation issues, sentence fragments, or confusing adjectives/adverbs) and showed a strong ability to self-correct. You voluntarily used advanced vocabulary and confidently experimented with creating new sentences.
        </h4>
        <h4 v-if="partData.part5.type === 'typeB'">
          Your grammar and vocabulary were at a basic level. You made a few grammar errors <input type="text" v-model="partData.part5.words" >(e.g., tense misuse, article/plural mistakes, verb collocation issues, sentence fragments, or confusing adjectives/adverbs) but caught on quickly when reminded. You were skilled at using familiar words and occasionally tried new ones, though you may misuse them at times.
        </h4>
        <h4 v-if="partData.part5.type === 'typeC'">
          Your grammar and vocabulary were developing and would benefit from focusing on basics first. You often made pronunciation errors or got stuck on new words, and you currently recognized mostly basic vocabulary. It would help to start with foundational grammar <input type="text" v-model="partData.part5.words" >(e.g., tense usage, article/plural rules, verb collocations, complete sentences, or adjective/adverb differences) and practice using new words in simple sentences step by step.
        </h4>
      </div>
    </Row>
    <Row>
      <div class="evaluate">
        <h2>Part three: Summary  :</h2>
        <h3>Summary of overall performance.  :<span class="choose">(Please choose a type)</span>  <span>
          <Button :type="partData.part6.type === 'typeA' ? 'primary' : 'default'" @click="changeType('part6', 'typeA')">typeA</Button>
          <Button :type="partData.part6.type === 'typeB' ? 'primary' : 'default'" @click="changeType('part6', 'typeB')">typeB</Button>
          <Button :type="partData.part6.type === 'typeC' ? 'primary' : 'default'" @click="changeType('part6', 'typeC')">typeC</Button>
        </span></h3>
        <h4 v-if="partData.part6.type === 'typeA'">
          Overall, I was thoroughly impressed with your engagement in today’s class! Your proactive questions and eagerness to experiment with new sentence structures made your participation truly standout. It was a joy to have you in class, and I’m already looking forward to our next session—keep up this fantastic energy!
        </h4>
        <h4 v-if="partData.part6.type === 'typeB'">
          Overall, your participation in class was great to see! While you occasionally needed a little nudge to share more, you jumped in willingly and kept the momentum going. Keep building on that—your effort shines through, and I can’t wait to see you grow even more in our next class!​
        </h4>
        <h4 v-if="partData.part6.type === 'typeC'">
          Overall, I appreciated seeing you step into class today—even if you felt a bit shy. You answered questions thoughtfully, and with a little patience, you opened up more than you might realize. Let’s keep that going! I’m looking forward to our next class, where I hope to hear your voice a little louder and see you start a conversation or two—you’ve got so much to share!
        </h4>
      </div>
    </Row>
    <Row>
      <div class="evaluate">
        <h2>Part four: Learning Suggestions  :</h2>
        <h4>
          The demo level is
          <select v-model="partData.part7.words" class="redBorder">
            <option v-for="item in levelNames" :value="item">{{ item }}</option>
          </select> for the student because <input type="text" v-model="partData.part8.words">(fill the reason if level is a bit difficult or a bit easy).
        </h4>
        <h2></h2>
        <h3>
          <span class="choose">(Please choose one or both suggestions for student.)</span>
        </h3>
        <h4>
          <input type="checkbox" v-model="partData.part9.words"> <span class="title">*suggestion 1*For listening and speaking practice,</span> it is recommended to listen to English songs, podcasts, English stories, etc., and engage in shadowing, imitation, and even retelling exercises. For difficult pronunciations and vocabulary, learn from teachers.
        </h4>
        <h4>
          <input type="checkbox" v-model="partData.part10.words"> <span class="title">*suggestion 2*In reading, grammar, and vocabulary sections,</span>
          try to read interesting English materials such as picture books and chapter books to accumulate vocabulary and sentence patterns through reading. For grammar, do targeted exercises on problematic grammar points to consolidate learning, and consult teachers for clarification on doubts.
        </h4>
        <h4>
          Also,  I suggest starting your English journey from <input type="text" v-model="evaluation"> (a particular level that we have) and taking classes twice or three times a week to ensure a great learning outcome.
        </h4>
      </div>
    </Row>
    <div slot="footer">
      <Button type="text" size="large" @click="onClose">Cancel</Button>
      <Button v-if="!readonly" type="primary" size="large" :loading="loading" @click="onSubmit">Submit</Button>
    </div>
  </Modal>
</template>
<script>
  export default {
    name: 'StudentWriteReviewDemoV2',
    props: {
      formData: {
        type: Object,
        default: {
          return: {
            part1: {
              type: '',
              words: ''
            },
            part2: {
              type: '',
              words: ''
            },
            part3: {
              type: '',
              words: ''
            },
            part4: {
              type: '',
              words: ''
            },
            part5: {
              type: '',
              words: 'a perfect fit'
            },
            part6: {
              type: '',
              words: ''
            },
            part7: {
              type: '',
              words: ''
            },
            part8: {
              type: '',
              words: ''
            },
            part9: {
              type: '',
              words: false
            },
            part10: {
              type: '',
              words: false
            }
          }
        }
      },
      value: {
        type: Boolean,
        default: {
          return: false
        }
      },
      openedId: {
        type: Number
      },
      reviewState: {
        type: Number
      },
      readonly: {
        type: Boolean,
        default: false
      }
    },
    data () {
      return {
        uid: '',
        openid: '',
        state: '',
        showModal: this.value,
        loading: false,
        lessonErrRule: {
          remark: [
            { type: 'string', required: true, message: ' ', trigger: 'blur' }
          ],
        },
        nickname: '',
        title: '',
        version: 1,
        evaluation: '',
        levels: ['Level 1', 'Level 2', 'Level 3', 'Level 4', 'Level 5', 'Level 6', 'Level 7', 'Level 8'],
        levelNames: ['a bit difficult', 'a perfect fit', 'a bit easy'],
        partData: {
          part1: {
            type: '',
            words: ''
          },
          part2: {
            type: '',
            words: ''
          },
          part3: {
            type: '',
            words: ''
          },
          part4: {
            type: '',
            words: ''
          },
          part5: {
            type: '',
            words: 'a perfect fit'
          },
          part6: {
            type: '',
            words: ''
          },
          part7: {
            type: '',
            words: ''
          },
          part8: {
            type: '',
            words: ''
          },
          part9: {
            type: '',
            words: false
          },
          part10: {
            type: '',
            words: false
          }
        }
      }
    },
    methods: {
      hasNumWords (str, num) {
        const words = str.split(' ') // 将字符串按空格切割成单词数组
        return words.length >= num // 判断单词数量是否大于等于80
      },
      onload () {
        let self = this
        self.$http.get('/bookTchFeedback/queryByLsnOpenId?lsnOpenId=' + self.openid).then(res => {
          let { uid, demoComment, nickname, title, version, evaluation } = res.data
          self.uid = uid
          self.nickname = nickname
          self.title = title
          self.version = version
          self.evaluation = evaluation
          if (demoComment) {
            console.log(demoComment)
            // 回显
            const dataObj = JSON.parse(demoComment)
            this.partData = {...this.partData, ...dataObj}
          } else {
            // 重置
            this.partData = {
              part1: {
                type: '',
                words: ''
              },
              part2: {
                type: '',
                words: ''
              },
              part3: {
                type: '',
                words: ''
              },
              part4: {
                type: '',
                words: ''
              },
              part5: {
                type: '',
                words: ''
              },
              part6: {
                type: '',
                words: ''
              },
              part7: {
                type: '',
                words: ''
              },
              part8: {
                type: '',
                words: ''
              },
              part9: {
                type: '',
                words: false
              },
              part10: {
                type: '',
                words: false
              }
            }
          }
        })
      },
      onClose () {
        this.$emit('on-close')
      },
      onSubmit () {
        let self = this
        if (self.partData.part1.type === '') {
          self.$Message.error('Part 1 requires priority selection')
          return
        }
        if (!self.partData.part2.type || !self.partData.part3.type || !self.partData.part3.words || !self.partData.part4.type || !self.partData.part5.type || !self.partData.part5.words) {
          self.$Message.error('Part 2 needs to be fully filled')
          return
        }
        if (!self.partData.part6.type) {
          self.$Message.error('Part 3 needs to be fully filled')
          return
        }
        if (!self.partData.part7.words) {
          self.$Message.error('Part 4 needs to be fully filled')
          return
        }

        if (!self.partData.part9.words && !self.partData.part10.words) {
          self.$Message.error('This suggestion requires selecting no less than one')
          return
        }
        if (!self.evaluation) {
          self.$Message.error("The student's English level must be entered (e.g. Level 5.1)")
          return
        }
        let isValid = self.evaluation
        if (isValid.includes('.')) {
          isValid = isValid.split('.')[0]
        } else {
          if (!self.levels.includes(isValid)) {
            self.$Message.error("The student's English level must be entered (e.g. Level 1 ~ Level 8)")
            return
          }
        }
        let parmas = {}
        parmas.demoComment = JSON.stringify(this.partData)
        parmas.lsnOpenId = self.openid
        parmas.reviewState = self.state
        parmas.uid = self.uid
        parmas.evaluation = self.evaluation
        parmas.version = 2
        this.$http.post('/bookTchFeedback/update', parmas).then(function (res) {
          self.$Message.success('success')
          self.showModal = false
        }).catch(function (e) {
          self.$Message.error('Failed to submit')
        })
      },
      changeType (key, value) {
        this.partData[key].type = value
        this.partData[key].words = ''
      },
    },
    watch: {
      reviewState (val) {
        this.state = val
      },
      openedId (val) {
        this.openid = val
      },
      value (val) {
        this.showModal = val
        if (val === true) {
            // this.scoreCompute()
          this.onload()
        } else {
          // this.feedback = {}
          // this.visible = val
        }
      },
      showModal (val) {
        if (val === false) {
          this.$emit('on-close')
        }
      },
      formData (val) {
        if (val) {
          this.lessonErrFormData = val
        }
      }
    }
  }
</script>



// WEBPACK FOOTER //
// StudentWriteReviewDemoV2Modal.vue?15acbcd4